export default __webpack_public_path__ + "static/media/service_bg.6f5dc2b2.gif";